import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import SidebarRow from "./SidebarRow";
import SpeedIcon from "@mui/icons-material/Speed";
import LocalFireDepartmentIcon from '@mui/icons-material/LocalFireDepartment';
import DirectionsCarIcon from "@mui/icons-material/DirectionsCar";
import FingerprintIcon from "@mui/icons-material/Fingerprint";
import GroupsIcon from "@mui/icons-material/Groups";
import FlutterDashIcon from '@mui/icons-material/FlutterDash';
import FortIcon from '@mui/icons-material/Fort';
import ShoppingBasketIcon from '@mui/icons-material/ShoppingBasket';
import ReduceCapacityIcon from '@mui/icons-material/ReduceCapacity';
import MilitaryTechIcon from "@mui/icons-material/MilitaryTech";
import AssignmentIcon from "@mui/icons-material/Assignment";
import EmailIcon from "@mui/icons-material/Email";
import CardGiftcardIcon from '@mui/icons-material/CardGiftcard';
import NotificationsActiveIcon from "@mui/icons-material/NotificationsActive";
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";
import AutoStoriesIcon from "@mui/icons-material/AutoStories";
import AddBusinessIcon from "@mui/icons-material/AddBusiness";
import CreditCardIcon from "@mui/icons-material/CreditCard";
import PowerSettingsNewIcon from "@mui/icons-material/PowerSettingsNew";
import Person2Icon from '@mui/icons-material/Person2';
import HubIcon from "@mui/icons-material/Hub";
import { useUser, useLogOut } from "../../context/UserContext";
import logo from "../../assets/imgs/pmall_logo_200.png";
import "./Builder.css";
import { useVendor } from "../../context/VendorSignupContext";

function Sidebar() {
  const { user, setUser } = useUser();
  const {
    visible,
    setVisible,
  } = useVendor();
  
  const logOut = useLogOut();
  const navigate = useNavigate();
  const getInitials = (name) => {
    if (name) {
      let arr = name?.split("");
      return arr[0];
    }
    return false;
  };
  
  useEffect(()=> {
    console.log(user);
  },[])
  return (
    // {}
    <>
      {user?.token && (
        <div className={`sidebar no-print  mobile-sidebar ${visible ? "mobile-sidebar-visible " : "mobile-sidebar"}`}>
          <div className="logo__holder">
            <img src={logo} alt="Pmall" style={{ width: 130 }} />
            {/* <h3> Logo </h3> */}
          </div>
{/* <h3 className="ml-20p" style={{fontSize: 11, color: '#ffb31f'}}> Administrators </h3> */}
          <div className="s-divider"></div>
          {user?.accountType == "Vendor" && <h5 className="sidebar_title_menu"> Vendor Resources </h5> }
          <div className="s-divider"></div>
          <SidebarRow
            path="/app/dashboard"
            Icon={SpeedIcon}
            title="Dashboard"
          />
          <SidebarRow
                path=""
                Icon={ShoppingBasketIcon}
                title="Market Place"
              />
               {user?.accountType == "Vendor" && (
            <>
              <SidebarRow
                path="/app/store-management"
                Icon={AddBusinessIcon}
                title="Store Products"
              />
              <SidebarRow
                path="/app/order-management"
                Icon={ShoppingCartIcon}
                title="Order Management"
              />
               <SidebarRow
                path="/app/users/details/"
                Icon={Person2Icon}
                title="My Profile"
              />      
               <SidebarRow
            path="/app/users"
            Icon={FlutterDashIcon}
            title="Vendor Store Managers"
          />
            </>
          )}
          {(user?.accountType === "Admin" ||
            user?.accountType === "Affiliate") && (
              <>
            <SidebarRow
              path="/app/vendors"
              Icon={GroupsIcon}
              title="Vendor Management"
            />
            <SidebarRow
            path="/app/users/details"
            Icon={Person2Icon}
            title="My Account Proflle"
          />
          </>
          )}

          {(
            user?.accountType === "Affiliate") && (
              <>
             <h5 className="sidebar_title_menu"> Market Place </h5>
            <SidebarRow
              path="/app/vendors"
              Icon={GroupsIcon}
              title="All Products to promote"
            />
            <SidebarRow
            path="/app/users/details"
            Icon={Person2Icon}
            title="High Converting Products"
          />
          <SidebarRow
            path="/app/users/details"
            Icon={Person2Icon}
            title="Trending Products"
          />
          <SidebarRow
            path="/app/users/details"
            Icon={Person2Icon}
            title="Vendor Spotlight"
          />
          </>
          )}    

          {(
            user?.accountType === "Affiliate") && (
              <>
             <h5 className="sidebar_title_menu"> My Business </h5>
            <SidebarRow
              path="/app/vendors"
              Icon={GroupsIcon}
              title="New Registration"
            />
            <SidebarRow
            path="/app/users/details"
            Icon={Person2Icon}
            title="Membership Upgrade"
          />
          <SidebarRow
            path="/app/users/details"
            Icon={Person2Icon}
            title="Leadership Rank"
          />
          <SidebarRow
            path="/app/users/details"
            Icon={Person2Icon}
            title="My Affiliate Link"
          />
          </>
          )}    
         

          {/* <div className="s-divider"></div> */}

          {(user?.accountType === "Vendor" ||
            user?.accountType === "Admin") && (
             <>
            <SidebarRow
              path="/app/products"
              Icon={ShoppingCartIcon}
              title="Product Management"
            />
            <SidebarRow
            path="/app/transaction/history"
            Icon={CreditCardIcon}
            title="Transactions"
          />
          </> 
          )}

          {user?.accountType === "Affiliate" && <h5 className="sidebar_title_menu"> Affiliate Resources </h5>}
          <div className="s-divider"></div>
          {/* <SidebarRow path="/app/front-desk"  Icon={HomeWorkIcon} title="Front Desk"/> */}
          {(user?.accountType === "Affiliate" ||
            user?.accountType === "Admin") && (
              <>
            <SidebarRow
              path="/app/affilates"
              Icon={HubIcon}
              title="Affiliate Management"
            />
              <SidebarRow
                path="/app/account/packages"
                Icon={CardGiftcardIcon}
                title="Account Packages"
              />
              <SidebarRow
                path="/app/leadership-rank"
                Icon={MilitaryTechIcon}
                title="Leadership Rank"
              />
               <SidebarRow
              path="/app/affilates"
              Icon={HubIcon}
              title="My Referral Link"
            />
              <SidebarRow
                path="/app/account/packages"
                Icon={CardGiftcardIcon}
                title="Banners & Media Kits"
              />
              <SidebarRow
                path="/app/leadership-rank"
                Icon={MilitaryTechIcon}
                title="Social Media Share Buttons"
              />
                 <SidebarRow
                path="/app/account/packages"
                Icon={CardGiftcardIcon}
                title="Coupons & Voucher"
              />
              <SidebarRow
                path="/app/leadership-rank"
                Icon={MilitaryTechIcon}
                title="Training Resources"
              />
              </>
          )}

        {user?.accountType === "Affiliate" && <h5 className="sidebar_title_menu"> Team Resources </h5>}
          <div className="s-divider"></div>
          {/* <SidebarRow path="/app/front-desk"  Icon={HomeWorkIcon} title="Front Desk"/> */}
          {(user?.accountType === "Affiliate" ) && (
              <>
            <SidebarRow
              path="/app/affilates"
              Icon={HubIcon}
              title="My Network"
            />
              <SidebarRow
                path="/app/network/genealogy/"
                Icon={ReduceCapacityIcon}
                title="Geneology"
              />
              <SidebarRow
                path="/app/leadership-rank"
                Icon={MilitaryTechIcon}
                title="Team Performance"
              />
              </>
          )}

{user?.accountType === "Affiliate" && <h5 className="sidebar_title_menu"> Utility </h5>}
          <div className="s-divider"></div>
          {/* <SidebarRow path="/app/front-desk"  Icon={HomeWorkIcon} title="Front Desk"/> */}
          {(user?.accountType === "Affiliate" ) && (
              <>
            <SidebarRow
              path="/app/affilates"
              Icon={HubIcon}
              title="iRecharge"
            />
              <SidebarRow
                path="/app/network/genealogy/"
                Icon={ReduceCapacityIcon}
                title="Mine PMT"
              />
              <SidebarRow
                path="/app/leadership-rank"
                Icon={MilitaryTechIcon}
                title="BluPay"
              />
              </>
          )}
          
          {user?.accountType === "Affiliate" && <h5 className="sidebar_title_menu"> Support & Settings </h5>}
          <div className="s-divider"></div>
          {/* <SidebarRow path="/app/front-desk"  Icon={HomeWorkIcon} title="Front Desk"/> */}
          {(user?.accountType === "Affiliate" ) && (
              <>
            <SidebarRow
              path="/app/affilates"
              Icon={HubIcon}
              title="Help Center"
            />
              <SidebarRow
                path="/app/network/genealogy/"
                Icon={ReduceCapacityIcon}
                title="All Reports"
              />
              <SidebarRow
                path="/app/leadership-rank"
                Icon={MilitaryTechIcon}
                title="Open Tickets"
              />
              </>
          )}

{/* <div className="s-divider"></div> */}
{user?.accountType === "Admin" && <h5 className="sidebar_title_menu"> Stockist Resources </h5>}
          <div className="s-divider"></div>
          {(user?.accountType === "Admin" ) && (
            <SidebarRow
              path="/app/stockist"
              Icon={DirectionsCarIcon}
              title="Dispatch Management"
            />
          )}
          
          {user?.accountType === "Vendor" &&
          <>
            <h5 className="sidebar_title_menu"> Messaging & Support </h5>
            <SidebarRow path="/app/messaging" Icon={EmailIcon} title="Messaging/Support" />
            <SidebarRow path="/app/help-center" Icon={EmailIcon} title="Help Center" />
            <SidebarRow path="/app/tickets" Icon={EmailIcon} title="Open Tickets" />
          </>
          }
         
         

        <h5 className="sidebar_title_menu"> Wallet </h5>
          <div className="s-divider"></div>
          {(user?.accountType === "Vendor") && (
            <>
              <SidebarRow
                path="/app/earnings"
                Icon={DirectionsCarIcon}
                title="My Earnings"
              />
              <SidebarRow path="/app/pending-payouts" Icon={EmailIcon} title="Pending Payouts" />

              <SidebarRow
                path="/app/fund-pmt"
                Icon={CreditCardIcon}
                title="Fund PMT"
              />
            </>
          )}
        
           { user?.accountType === "Affiliate" && (
              <>
                <SidebarRow
                path="/app/fund-pmt"
                Icon={CreditCardIcon}
                title="All Wallets"
                />
                <SidebarRow
                  path="/app/fund-pmt"
                  Icon={CreditCardIcon}
                  title="Transaction History"
                />
              </>
           )}
        {user?.accountType !== "Customer" && (
          <SidebarRow
            path="/app/withdrawals"
            Icon={LocalFireDepartmentIcon}
            title="Withdrawal"
          />
          )}

          {user?.accountType === "Vendor" &&
          <>
          <h5 className="sidebar_title_menu"> Spotlight </h5>
          <div className="s-divider"></div>
          {(user?.accountType === "Vendor") && (
            <SidebarRow
              path="/app/Spotlight"
              Icon={DirectionsCarIcon}
              title="Spotlight Promotion"
            />
          )}
          <SidebarRow path="/app/combo-products" Icon={EmailIcon} title="Combo Products" />

          <SidebarRow
            path="/app/discounts"
            Icon={CreditCardIcon}
            title="Discounts & Coupons Builder"
          />

          <h5 className="sidebar_title_menu"> Reviews & Ratings </h5>
          <div className="s-divider"></div>
          {(user?.accountType === "Vendor") && (
            <SidebarRow
              path="/app/reviews"
              Icon={DirectionsCarIcon}
              title="Product Reviews"
            />
          )}
          <SidebarRow path="/app/customer-feedbacks" Icon={EmailIcon} title="Customer Feedbacks" />

          <SidebarRow
            path="/app/reviews-response"
            Icon={CreditCardIcon}
            title="Response To Reviews"
          />
          </>
          }
          <h5 className="sidebar_title_menu">My Settings </h5>
          <div className="s-divider"></div>
          {(user?.accountType === "Vendor") && (
            <>
            <SidebarRow
              path="/app/profile-settings"
              Icon={DirectionsCarIcon}
              title="Profile Settings"
            />
            <SidebarRow path="/app/bank-details" Icon={EmailIcon} title="Bank Details" />

            <SidebarRow
              path="/app/wallet-settings"
              Icon={CreditCardIcon}
              title="Wallet Settings"
            />

              <SidebarRow
              path="/app/security"
              Icon={CreditCardIcon}
              title="Security"
            />
            </>
          )}

          {(user?.accountType === "Vendor" || user?.accountType === "Affiliate") && (
            <>
            <SidebarRow
              path="/app/profile-settings"
              Icon={DirectionsCarIcon}
              title="Profile Settings"
            />
            <SidebarRow path="/app/bank-details" Icon={EmailIcon} title="Bank Details" />

            <SidebarRow
              path="/app/wallet-settings"
              Icon={CreditCardIcon}
              title="Wallet Settings"
            />

              <SidebarRow
              path="/app/security"
              Icon={CreditCardIcon}
              title="Security"
            />
            </>
          )}    
      
         
         

{/* <div className="s-divider"></div> */}
          <h5 className="sidebar_title_menu"> Administration </h5>
          <div className="s-divider"></div>


          {user?.accountType === "Admin" && (
            <>
            {/* <SidebarRow
              path="/app"
              Icon={AssignmentIcon}
              title="User Account"
            /> */}
            <SidebarRow
              path="/app"
              Icon={AssignmentIcon}
              title="PMall Reports"
            />
            <SidebarRow
                path="/app/advert_maker"
                Icon={CardGiftcardIcon}
                title="Promotions"
              />
            </>
          )}
          <SidebarRow
            Icon={PowerSettingsNewIcon}
            title="Log Out"
            onClick={logOut}
          />

          <div className="w-100 f-bottom">
            <div className="s-divider"></div>
            {user?.accountType !== "Customer" && (
              <>
            <SidebarRow
              path="/app/config"
              Icon={FingerprintIcon}
              title="Control Panel Config"
            />
            <SidebarRow
              path="/app/documentation"
              Icon={AutoStoriesIcon}
              title="Documentation"
            />
            <SidebarRow
              path="/app/notifications"
              Icon={NotificationsActiveIcon}
              title="Notification"
            />
            </>
            )}

            <div className="header__info" style={{marginTop: 20}}>
              <div className="user__avatar bg-warning">
              <h3>
                {user.accountType === "Stockist"
                  ? getInitials(user?.name)
                  : `${getInitials(user?.fname)} ${getInitials(user?.lname)}`
                }
              </h3>

              </div>
              <h4 className="title-case c-chalk">
                {user?.name}
                {user?.fname} {user?.lname} <br />
                <span className="summary__label font-9 role">
                  {user?.accountType}
                </span>
              </h4>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default Sidebar;